var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Data } from './data';
import { Slot } from './slot';
var OpeningHours = /** @class */ (function (_super) {
    __extends(OpeningHours, _super);
    function OpeningHours() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.class = "OpeningHours";
        return _this;
    }
    OpeningHours.isDateOpen = function (oh, time) {
        if (!oh)
            return true;
        if (oh.always)
            return true;
        //check ovewrites, holidays, and then normal hours
        var day = new Date(time);
        console.log("day", day.getDate());
        if (oh.overwrites) {
            for (var _i = 0, _a = oh.overwrites; _i < _a.length; _i++) {
                var slot = _a[_i];
                if (Slot.isWithinDayRange(slot, time)) {
                    console.log("within overwrites", slot);
                    if (Slot.isOpenType(slot)) {
                        console.log("overwrite true");
                        return true;
                    }
                    else {
                        console.log("overwrite false");
                        return false;
                    }
                }
            }
        }
        var ph1Slot;
        var ph2Slot;
        if (oh.holidays) {
            for (var _b = 0, _c = oh.holidays; _b < _c.length; _b++) {
                var slot = _c[_b];
                if (slot.weekday == 101) {
                    ph1Slot = slot;
                    console.log("ph1", slot);
                }
                else if (slot.weekday == 102) {
                    ph2Slot = slot;
                    console.log("ph2", slot);
                }
                else if (Slot.isWithinDayRange(slot, time)) {
                    console.log("within real holiday", slot);
                    if (Slot.isOpenType(slot)) {
                        console.log("holiday true");
                        return true;
                    }
                    else {
                        console.log("holiday false");
                        return false;
                    }
                }
            }
        }
        if (oh.ph1 && ph1Slot) {
            for (var _d = 0, _e = oh.ph1; _d < _e.length; _d++) {
                var slot = _e[_d];
                if (Slot.isWithinDayRange(slot, time)) {
                    console.log("within holiday1", slot);
                    if (Slot.isOpenType(ph1Slot)) {
                        console.log("holiday true");
                        return true;
                    }
                    else {
                        console.log("holiday false");
                        return false;
                    }
                }
            }
        }
        if (oh.ph2 && ph2Slot) {
            for (var _f = 0, _g = oh.ph2; _f < _g.length; _f++) {
                var slot = _g[_f];
                if (Slot.isWithinDayRange(slot, time)) {
                    console.log("within holiday2", slot);
                    if (Slot.isOpenType(ph2Slot)) {
                        console.log("holiday true");
                        return true;
                    }
                    else {
                        console.log("holiday false");
                        return false;
                    }
                }
            }
        }
        if (oh.weekdays) {
            for (var _h = 0, _j = oh.weekdays; _h < _j.length; _h++) {
                var slot = _j[_h];
                if (Slot.isWeekdayOpen(slot, time)) {
                    console.log("weekday open");
                    return true;
                }
            }
        }
        else {
            console.log("weekdays not set, open");
            return true;
        }
        console.log("none match closed", oh);
        return false;
    };
    OpeningHours.isTimeOpen = function (brandOh, oh, time) {
        if (!oh)
            return true;
        if (oh.always)
            return true;
        console.log("brand OpeningHours", brandOh);
        var day = new Date(time);
        console.log("day", day.getDate());
        if (oh.overwrites) {
            for (var _i = 0, _a = oh.overwrites; _i < _a.length; _i++) {
                var slot = _a[_i];
                if (Slot.isWithinDayRange(slot, time)) {
                    console.log("within overwrites", slot);
                    if (Slot.isTimeOpen(slot, time, false)) {
                        console.log("overwrite true");
                        return true;
                    }
                    else {
                        console.log("overwrite false");
                        return false;
                    }
                }
            }
        }
        var ph1Slot;
        var ph2Slot;
        if (oh.holidays) {
            for (var _b = 0, _c = oh.holidays; _b < _c.length; _b++) {
                var slot = _c[_b];
                if (slot.weekday == 101) {
                    ph1Slot = slot;
                    console.log("ph1", slot);
                }
                else if (slot.weekday == 102) {
                    ph2Slot = slot;
                    console.log("ph2", slot);
                }
                else if (Slot.isWithinDayRange(slot, time)) {
                    console.log("within holiday", slot);
                    if (Slot.isTimeOpen(slot, time, false)) {
                        console.log("holiday true");
                        return true;
                    }
                    else {
                        console.log("holiday false");
                        return false;
                    }
                }
            }
        }
        if (brandOh && brandOh.ph1 && ph1Slot) {
            for (var _d = 0, _e = brandOh.ph1; _d < _e.length; _d++) {
                var slot = _e[_d];
                slot.startTime = ph1Slot.startTime;
                slot.endTime = ph1Slot.endTime;
                if (Slot.isWithinDayRange(slot, time)) {
                    console.log("within holiday1", slot);
                    if (Slot.isTimeOpen(ph1Slot, time, false)) {
                        console.log("holiday true");
                        return true;
                    }
                    else {
                        console.log("holiday false");
                        return false;
                    }
                }
            }
        }
        if (brandOh && brandOh.ph2 && ph2Slot) {
            for (var _f = 0, _g = brandOh.ph2; _f < _g.length; _f++) {
                var slot = _g[_f];
                slot.startTime = ph2Slot.startTime;
                slot.endTime = ph2Slot.endTime;
                if (Slot.isWithinDayRange(slot, time)) {
                    console.log("within holiday2", slot);
                    if (Slot.isTimeOpen(ph2Slot, time, false)) {
                        console.log("holiday true");
                        return true;
                    }
                    else {
                        console.log("holiday false");
                        return false;
                    }
                }
            }
        }
        if (oh.weekdays) {
            for (var _h = 0, _j = oh.weekdays; _h < _j.length; _h++) {
                var slot = _j[_h];
                if (Slot.isTimeOpen(slot, time, true)) {
                    console.log("weekday open");
                    return true;
                }
            }
        }
        else {
            console.log("weekdays not set, open");
            return true;
        }
        console.log("should close");
        return false;
    };
    return OpeningHours;
}(Data));
export { OpeningHours };
//# sourceMappingURL=opening-hours.js.map